import { render, staticRenderFns } from "./DialogsPostsListImmo.vue?vue&type=template&id=6c0f809e&scoped=true&"
import script from "./DialogsPostsListImmo.vue?vue&type=script&lang=js&"
export * from "./DialogsPostsListImmo.vue?vue&type=script&lang=js&"
import style0 from "./DialogsPostsListImmo.vue?vue&type=style&index=0&id=6c0f809e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f809e",
  null
  
)

export default component.exports